module.exports = __webpack_public_path__ + "static/media/optaplan-timeline-poster.3f223182.png";